import { render } from "./ProgressBar.vue?vue&type=template&id=2b63fcae&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"

import "./ProgressBar.vue?vue&type=style&index=0&id=2b63fcae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b63fcae"

export default script